import React from 'react'

import { func, string } from 'prop-types'

import i18n from 'Pods/Shared/I18n'

import { suggestEmail } from 'Utils/emailSuggestion'

function EmailSuggestion({ email, onAccept, className = '' }) {
  const suggestion = suggestEmail(email)

  if (!suggestion) return null

  // The global i18n language stays 'en'; translations resolve by passing the
  // page locale per call, matching the repo-wide `lng: locale` convention.
  // Safe to read the DOM here - this component never renders during SSR.
  const locale = document.documentElement.lang || 'en'

  return (
    <p className={`email-suggestion cgt-caption ${className}`.trim()} role="status">
      {i18n.t('email_suggestion.prefix', { ns: 'rails', lng: locale })}
      {' '}
      {suggestion.address}
      @
      <button
        type="button"
        className="email-suggestion__link cgt-link-primary-accented"
        onClick={() => onAccept(suggestion.full)}
        aria-label={i18n.t('email_suggestion.accept_label', { ns: 'rails', lng: locale, email: suggestion.full })}
      >
        <strong>{suggestion.domain}</strong>
      </button>
      {i18n.t('email_suggestion.suffix', { ns: 'rails', lng: locale })}
    </p>
  )
}

EmailSuggestion.propTypes = {
  email: string.isRequired,
  onAccept: func.isRequired,
  className: string,
}

export default EmailSuggestion
